export default __webpack_public_path__ + "static/cer-5-8ae7cd7e308b1364a7cec12cceab3d31.webp";